import axios from "axios";
import { Announcement, AnnouncementSummary } from "./dto/Announcement";

// お知らせ一覧取得
export const getAnnouncements = async (): Promise<AnnouncementSummary[]> => {
  const res = await axios.get<AnnouncementSummary[]>(`/api/notice/list`, {
    headers: { "Content-Type": "application/json;charset=utf-8" },
  });
  return res.data;
};

// お知らせ取得
export const getAnnouncement = async (id: string): Promise<Announcement> => {
  const res = await axios.get<Announcement>(`/api/notice?id=${id}`, {
    headers: { "Content-Type": "application/json;charset=utf-8" },
  });
  return res.data;
};
